export type BrandKey = "erpbridge" | "erpsync";

export interface BrandConfig {
  key: BrandKey;
  name: string;
  compactName: string;
  docsUrl: string;
  supportUrl: string;
  websiteUrl: string;
  installerName: string;
}

export const getBrandKey = (hostname: string): BrandKey =>
  hostname.toLowerCase().includes("erpsync") ? "erpsync" : "erpbridge";

export const getBrandConfig = (hostname: string): BrandConfig => {
  const key = getBrandKey(hostname);
  const isErpSync = key === "erpsync";

  return {
    key,
    name: isErpSync ? "ERP Sync" : "ERP Bridge",
    compactName: isErpSync ? "ERPSync" : "ERPBridge",
    docsUrl: `https://docs.${key}.io`,
    supportUrl: `https://${key}.dma.it`,
    websiteUrl: `https://${key}.io`,
    installerName: isErpSync ? "ERPSync" : "ERPBridge",
  };
};

const hostname = typeof window === "undefined" ? "" : window.location.hostname;

export const BRAND = getBrandConfig(hostname);

export const getDocsUrl = (path = ""): string => `${BRAND.docsUrl}${path}`;

